import API from "../configs/axiosInstance";

const getFavoriteList = () => {
    return API({
        url: `account-service/v1/favorite-menus`,
        method: 'GET',
    });
};

const addFavorite = (data) => {
    return API({
        url: `account-service/v1/favorite-menus`,
        method: 'POST',
        ...data
    });
}

const deleteFavorite = (module) => {
    return API({
        url: `account-service/v1/favorite-menus/${module}`,
        method: 'DELETE',
    });
};

const reorderFavoriteList = (data) => {
    return API({
        url: `account-service/v1/favorite-menus`,
        method: 'PUT',
        ...data
    });
}

const favoritesMenuService = {
    getFavoriteList,
    addFavorite,
    deleteFavorite,
    reorderFavoriteList
};

export default favoritesMenuService;
